import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

import buildPath from '../utilities/buildPath';

const PATH_TEMPLATE =
  '/workflows/user-workflows/{userWorkflowId}/questionnaires/generate-pdf/{pdfTemplateId}/using-compiled-template';
type THIS_API = ApiDefinition[typeof PATH_TEMPLATE]['POST'];
type Input = THIS_API['params'] & THIS_API['body'];
type Output = THIS_API['response'];

const generateFormPDFUsingCompiledTemplate = async ({
  userWorkflowId,
  compiledHtmlTemplate,
  cssContent,
  pdfTemplateId,
}: Input): Promise<Output> => {
  const response = await noodleApiClient.post(buildPath<THIS_API>(PATH_TEMPLATE, { pdfTemplateId, userWorkflowId }), {
    compiledHtmlTemplate,
    cssContent,
  });
  return response.data;
};

export default generateFormPDFUsingCompiledTemplate;
